import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { SearchTextField } from "@/controls/quick-filter-textfield/SearchTextField";
import { Button, Grid, Typography } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { CatalogMechanicalTest } from "../../../models/CatalogMechanicalTest";
import { useGridStyles } from "../../../styles/gridStyles";
import { CreateMechanicalTest } from "./CreateMechanicalTest";
import { EditMechanicalTest } from "./EditMechanicalTest";
import { useTableData } from "./hooks";

type Props = {
	getCatalogMechanicalTestsFromAPI: Function;
	isLoading: boolean;
};

export const TableMechanicalTest = ({
	getCatalogMechanicalTestsFromAPI,
	isLoading,
}: Props) => {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [id, setId] = useState<number | null>(null);
	const [quickFilterText, setQuickFilterText] = useState("");
	const { rows, columns, defaultColDef } = useTableData({});
	const { columnDefaults, columnTypes } = useGridDefinitions({
		OnEdit: (data: CatalogMechanicalTest) => {
			setShowEditModal(!showEditModal);
			setId(data.MechanicatTestId);
		},
	});
	const classes = useGridStyles();

	return (
		<>
			<Grid item xs={12} container justifyContent="center" spacing={1}>
				<Grid item md={12} xs={12}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Mechanical Tests
					</Typography>
				</Grid>

				<Grid
					item
					xs={12}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid item xs={12} style={{ marginBottom: 10 }}>
						<SearchTextField
							value={quickFilterText}
							onChange={(text) => setQuickFilterText(text)}
							label="Search mechanical test"
						/>
					</Grid>
					<Grid
						item
						md={12}
						xs={12}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columns}
								getRowId={(params) => params.data.MechanicatTestId}
								columnTypes={columnTypes}
								suppressContextMenu
								onRowDoubleClicked={(params) => {
									setId(params.data.MechanicatTestId);
									setShowEditModal(true);
								}}
								rowSelection="single"
								quickFilterText={quickFilterText}
							/>
						</div>
					</Grid>

					<Grid item md={"auto"} xs={12} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => setShowCreateModal(!showCreateModal)}
						>
							NEW MECHANICAL TEST
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<CreateMechanicalTest
				show={showCreateModal}
				onHide={() => setShowCreateModal(false)}
				refreshData={getCatalogMechanicalTestsFromAPI}
			/>
			<EditMechanicalTest
				show={showEditModal}
				onHide={(updated: boolean) => {
					setShowEditModal(false);
					setId(null);
					if (updated) getCatalogMechanicalTestsFromAPI();
				}}
				mechanicalTestId={id}
			/>
		</>
	);
};
